import { createFileRoute } from "@tanstack/react-router";
import { Table } from "@heroui/react";

import { useCities } from "@/features/city/use-cities.ts";
import { CityEntity } from "@/features/city/type.ts";
import {
  CreateCityModal,
  EditCityModal,
  DeleteCityModal,
} from "@/features/city";
import { PageLayout } from "@/shared/components/page-layout.ui.tsx";

export const Route = createFileRoute("/dashboard/cities")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data } = useCities();

  return (
    <PageLayout actions={<CreateCityModal />} title="Города">
      <Table.Root>
        <Table.Content aria-label="Список городов">
          <Table.Header>
            <Table.Column>ID</Table.Column>
            <Table.Column>Название</Table.Column>
            <Table.Column>Страна</Table.Column>
            <Table.Column> </Table.Column>
          </Table.Header>
          <Table.Body items={data.data}>
            {(city: CityEntity) => (
              <Table.Row id={String(city.id)}>
                <Table.Cell>{city.id}</Table.Cell>
                <Table.Cell>{city.name}</Table.Cell>
                <Table.Cell>{city.country}</Table.Cell>
                <Table.Cell>
                  <div className="flex flex-row gap-2 justify-end">
                    <EditCityModal city={city} />

                    <DeleteCityModal cityId={city.id} />
                  </div>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table.Content>
      </Table.Root>
    </PageLayout>
  );
}
